import { FacebookIcon, LinkedinIcon, LinkIcon, XIcon } from "@eworkit/iris";
import React, { FC } from "react";

import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";

import "./_share-button-option.scss";

interface IShareButtonOptionProps {
  icon: string;
  text: string;
  onClick: () => void;
}

const getShareButtonOptionIcon = (target: string) => {
  switch (target) {
    case "facebook":
      return FacebookIcon;
    case "twitter":
      return XIcon;
    case "linkedin":
      return LinkedinIcon;
    default:
      return LinkIcon;
  }
};

export const ShareButtonOption: FC<IShareButtonOptionProps> = ({ icon, text, onClick }) => {
  const baseClass = "share-button-option";
  const Icon = getShareButtonOptionIcon(icon);

  return (
    <div className={baseClass} onClick={onClick}>
      <Flex padding={["sm", "md"]} innerMargin="sm" align="center" justify="center">
        <Icon size="sm" color="n500" />
        <Flex grow={1}>
          <Text size="md" color="grey1">
            {text}
          </Text>
        </Flex>
      </Flex>
    </div>
  );
};
